import {
  GraphQlClient,
} from '@intelipost-js/secure-providers';
import {
  ScToast,
} from '@intelipost-js/secure-components';

export default {
  getShipperEvents({ commit }) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
      query {
        shipperEvents {
          micro {
            id
            code
            description
          }
          macro {
            id
            code
            description
          }
          base {
            id
            code
            description
          }
          source_id
        }
      }`)
      .then((res) => {
        const {
          data = {},
        } = res || {};
        const {
          shipperEvents = [],
        } = data || {};

        commit('toggleLoading', false);
        commit('setShipperEvents', shipperEvents);

        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);

        return Promise.reject(err);
      });
  },
  getShipperEventsById({ commit }, id) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
      query (
        $id: Int!
      ) {
        shipperEventsById(id:$id) {
          micro {
            id
            code
            description
          }
          macro {
            id
            code
            description
          }
          base {
            id
            code
            description
          }
          source_id
        }
      }`, { id })
      .then((res) => {
        const {
          data = {},
        } = res || {};
        const {
          shipperEventsById = [],
        } = data || {};

        commit('toggleLoading', false);
        commit('setShipperForm', shipperEventsById);

        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  removeShipperEvent({ commit, dispatch }, id) {
    return GraphQlClient.mutation(`
      mutation (
        $base_id: Int!
      ){
        removeShipperEvent(
          base_id: $base_id
        ){
          base {
            id
          }
        }
      }`, { base_id: id })
      .then((res) => {
        commit('toggleLoading', false);
        ScToast.success('Evento removido com sucesso');

        dispatch('getShipperEvents');

        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);

        return Promise.reject(err);
      });
  },
  createShipperEvent({ commit }, { micro, base }) {
    const {
      id,
    } = micro;
    const {
      description,
      code,
    } = base;

    commit('toggleLoading', true);

    return GraphQlClient.mutation(`
      mutation (
        $id: Int!
        $code: String!
        $description: String
        ){
        createShipperEvent(
          id: $id
          code: $code
          description: $description
        ){
          micro {
            id
          }
        }
      }`, {
        id,
        code,
        description,
      })
      .then((res) => {
        commit('toggleLoading', false);

        ScToast.success('Evento salvo com sucesso');

        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);

        return Promise.reject(err);
      });
  },

  editShipperEvent({ commit }, { micro, base }) {
    const {
      id,
    } = micro;
    const {
      description,
      code,
      id: base_id,
    } = base;

    commit('toggleLoading', true);

    return GraphQlClient.mutation(`
      mutation (
        $id: Int!
        $code: String!
        $description: String!
        $base_id: Int!
      ){
        editShipperEvent(
          id: $id
          code: $code
          description: $description
          base_id: $base_id
        ){
          base {
            id
          }
        }
      }`, {
        id,
        description,
        code,
        base_id,
      })
      .then((res) => {
        commit('toggleLoading', false);

        ScToast.success('Evento editado com sucesso');

        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);

        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/manage-events-order/pages/event-shipper/store/actions.js